
import MainPage from './component/MainPage';
function App() {
  return (
    <div>
      <MainPage></MainPage>
    </div>
   
  );
}
export default App;
